import { prompt, type PromptDefinition } from './models';

export const STRATA_MANAGER_PROMPTS = [
    prompt(
        'Meet obligations',
        'What matters in this building require owners corporation follow-up?',
        'Which buildings have owners corporation matters awaiting follow-up?'
    ),
    prompt(
        'Meet obligations',
        'What common-property maintenance is documented as due for this building?',
        'Which buildings have common-property maintenance needing strata coordination?'
    ),
    prompt(
        'Meet obligations',
        "Which resolutions in this building's meeting records still need action?",
        'Which buildings have unresolved actions from strata meeting resolutions?'
    ),
    prompt(
        'Meet obligations',
        'Find strata meeting records for this building relating to…',
        'Find strata meeting records across my buildings relating to…',
        'prefill'
    ),
    prompt(
        'Meet obligations',
        'What responsibilities are documented for lots and common property in this building?',
        'Which buildings have unclear lot-versus-common-property responsibilities in their records?'
    ),
    prompt(
        'Manage risk',
        'What strata insurance details and renewal dates are recorded for this building?',
        'Which buildings have strata insurance renewals or evidence gaps to follow up?'
    ),
    prompt(
        'Keep it running',
        'What common-property capital works are proposed for this building?',
        'Compare proposed common-property capital works across my buildings.'
    ),
    prompt(
        'Meet obligations',
        'Find strata by-laws or rules for this building covering…',
        'Find strata by-laws or rules across my buildings covering…',
        'prefill'
    ),
    prompt(
        'Meet obligations',
        "Which owner requests or disputes remain open in this building's strata records?",
        'Which buildings have unresolved owner requests or strata disputes?'
    ),
    prompt(
        'Meet obligations',
        "What compliance evidence should accompany this building's strata committee report?",
        'Which buildings have compliance evidence gaps for strata committee reporting?'
    ),
    prompt(
        'Meet obligations',
        "What documents are missing from this building's strata management handover?",
        'Compare strata management handover gaps across my buildings.'
    ),
    prompt(
        'Meet obligations',
        'Prepare a strata committee update for this building focused on…',
        'Prepare a strata management priorities summary across my buildings focused on…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
